import "@fontsource/lexend";
import "@fontsource/lexend/100.css";
import "@fontsource/lexend/200.css";
import "@fontsource/lexend/300.css";
import "@fontsource/lexend/400.css";
import "@fontsource/lexend/500.css";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import "@fontsource/lexend/800.css";
import "@fontsource/lexend/900.css";
import { useEffect } from 'react';
import './deletion-page.css';

export default function DeletionPage() {
    useEffect(() => {
        document.title = "Marlo - User Data Deletion Policy";
    }, []);

    return (
        <div className="deletion-page">
            <div className="deletion-content">
            <h1>User Data Deletion Policy</h1>
            <hr />
            At <b>Marlo</b>, we respect your privacy and believe you should have full control over your personal information. This policy explains how you can request deletion of your data associated with your use of the Marlo platform.
            <hr />
            <h2>What data can be deleted?</h2>
            Upon your request, we will permanently delete the following information:
            <ul>
                <li>
                    Your account details (email, phone number, username, profile)
                </li>
                <li>
                    Activity participation records
                </li>
                <li>
                    Chat history and interactions
                </li>
                <li>
                    Social scores, ratings, and level history
                </li>
                <li>
                    Any other personal data stored on Marlo’s systems
                </li>
            </ul>
            <hr />
            <h2>How to request data deletion</h2>
            You can request your data to be deleted by contacting us：
            <ol>
                <li>
                    <b>Email</b><br />
                    Send your request to: hello[**@himarlo.com**](mailto:support@himarlo.com) <br />
                    Please include your username and registered email or phone number for verification.
                </li>
            </ol>
            <hr />
            <h2>Processing time</h2>
            Once we receive your request and verify your identity, we will process your data deletion within **7 business days**. You will receive a confirmation email once the deletion is complete.
            <br /><br />
            <hr />
            <h2>Important Notes</h2>
            <ul>
                <li>
                    Data deletion is **permanent and irreversible**.
                </li>
                <li>
                    If you are part of any active events, deletion will cancel your participation and remove all related records.
                </li>
                <li>
                    Some anonymized or aggregated data (non-identifiable) may be retained for analytical purposes, as permitted by law.
                </li>
            </ul>
            <hr />
            <h2>Need Help?</h2>
            If you have any questions about this policy or need assistance, please contact us at:
            <b>hello[@himarlo.com](mailto:support@himarlo.com)</b>
            </div>
        </div>
    )
}